import { useQuery as _ } from "./contact-channels42.js";
import { useContactChannelsContext as M } from "./contact-channels19.js";
import { useTranslations as O } from "./contact-channels43.js";
import { getPhoneSchedule as A } from "./contact-channels46.js";
import { formatPhoneSchedules as D } from "./contact-channels47.js";
import { useCheckC2CSpam as I } from "./contact-channels48.js";
import { useEmergencyCheck as P } from "./contact-channels2.js";
import { CHANNELS_CONFIG as B } from "./contact-channels49.js";
import { NRLogger as u } from "./contact-channels45.js";
import { Logger as N } from "./contact-channels50.js";
const J = (n = !0) => {
  const { proadvantageType: f, isProadvantage: o, loadingProAdvantage: g, tenant: t, locale: i } = M(), { t: a } = O(), { data: l, isLoading: S } = P(n), { data: b, isLoading: y } = I(n), { data: E, isLoading: L } = _({
    queryKey: ["phoneSchedule"],
    queryFn: () => A(t, i),
    staleTime: 5 * 60 * 1e3,
    gcTime: 5 * 60 * 1e3,
    enabled: n
  });
  return _({
    queryKey: ["c2c"],
    queryFn: async () => {
      var h, p, v;
      if (l != null && l.enabled && (l != null && l.config.c2cDisabled))
        return u.warn("Contact Channels: useCallMe", {
          emergencyEnabled: l.enabled,
          c2cDisabled: l.config.c2cDisabled,
          locale: i,
          tenant: t,
          message: "CallMe service is disabled due to emergency"
        }), {
          isAvailable: !1,
          availabilityInfo: {
            emergencyMessage: l.message,
            reason: "EMERGENCY"
          },
          ui: {
            title: a("call_me.title"),
            description: a("call_me.service_unavailable")
          }
        };
      if (!b)
        return u.warn("Contact Channels: useCallMe", {
          message: "CallMe service is unavailable due to spam protection",
          reason: "BLOCKED",
          locale: i,
          tenant: t,
          spamProtection: !1
        }), {
          isAvailable: !1,
          availabilityInfo: {
            reason: "BLOCKED"
          },
          ui: {
            title: a("call_me.title"),
            description: a("call_me.service_unavailable")
          }
        };
      const { status: r, businessHours: e } = E || {}, { contactUsComponents: c } = B[i == null ? void 0 : i.toLowerCase()], C = c == null ? void 0 : c.includes("call_me_v2"), { isFeatureEnabled: s, isScheduleOpen: m } = r || {};
      if (!r || !s || o || !C)
        return u.warn("Contact Channels: useCallMe", {
          message: "CallMe service is disabled",
          reason: "DISABLED",
          hasStatus: !!r,
          locale: i,
          tenant: t,
          isFeatureEnabled: s || !1,
          isProadvantage: o || !1,
          isCallMeEnabledByLocale: C || !1
        }), {
          isAvailable: !1,
          availabilityInfo: {
            reason: "DISABLED"
          },
          ui: {
            title: a("call_me.title"),
            description: a("call_me.service_unavailable")
          }
        };
      const d = D((e == null ? void 0 : e.schedule) || []);
      return m ? {
        isAvailable: !0,
        plainData: {
          schedule: d,
          timezone: ((v = e == null ? void 0 : e.timezone) == null ? void 0 : v.short_format) || "",
          isScheduleOpen: m,
          isFeatureEnabled: s,
          isProadvantage: o,
          proadvantageType: f
        },
        ui: {
          title: a("call_me.buttons.call_me_online.title"),
          description: a("call_me.buttons.call_me_online.description")
        }
      } : (N.warn("Contact Channels: useCallMe", {
        message: "CallMe service is unavailable due to business hours",
        reason: "OUT_OF_BUISNESS_HOURS",
        isScheduleOpen: !1,
        locale: i,
        tenant: t,
        formattedSchedule: JSON.stringify(d),
        timezone: ((h = e == null ? void 0 : e.timezone) == null ? void 0 : h.short_format) || ""
      }), {
        isAvailable: !1,
        availabilityInfo: {
          reason: "OUT_OF_BUISNESS_HOURS"
        },
        plainData: {
          schedule: d,
          timezone: ((p = e == null ? void 0 : e.timezone) == null ? void 0 : p.short_format) || "",
          isScheduleOpen: m || !1,
          isFeatureEnabled: s,
          isProadvantage: o,
          proadvantageType: f
        },
        ui: {
          title: a("call_me.title"),
          description: a("call_me.service_unavailable")
        }
      });
    },
    staleTime: 5 * 60 * 1e3,
    gcTime: 5 * 60 * 1e3,
    retry: 2,
    enabled: !S && !L && !g && !y && n
  });
};
export {
  J as useCallMe
};
//# sourceMappingURL=contact-channels4.js.map
